import axios from "axios";
import { centerAllotMedicine, medicineCRUD, medicinePurchases } from "../../constants/apis/clinic_apis";
import { getUserToken } from "../../utils/localStoarege";

export const getMedicines = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(medicineCRUD, config);
    return response;
};

export const addNewMedicine = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(medicineCRUD, data, config);
    return response;
};

export const updateMedicineQuantity = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(medicinePurchases, data, config);
    return response;
};

export const updateMedicine = async (data, id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(medicineCRUD + id, data, config);
    return response;
};

export const allotMedicine = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(centerAllotMedicine, data, config);
    return response;
};

export const allotMedicineHistory = async (medicineId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(centerAllotMedicine + "?medicine_id=" + medicineId, config);
    return response;
};

export const historyMedicineQuantity = async (medicineId) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${getUserToken()}`,
        },
    };
    const response = await axios.get(medicinePurchases + "?medicine_id=" + medicineId, config);
    return response;
};